import React from 'react'
import { FormattedMessage } from 'react-intl';
import './SSO-CMS.css'


class SSOConnecting extends React.Component {
    render() {
        return(
            <div className='card'>
                <div className='text-center'>
                    <img className="label_hover" alt="cloud icon" src="/images/cloud-red.svg" />                  
                </div>
                <div className='header text-center mt-3'>
                    <h2><FormattedMessage id="CONNECTIONG_TO_CLOUD" /></h2>
                </div>
                <div className='d-flex justify-content-center mt-2'>
                    <div class="spinner-border red" role="status">
                    </div>
                </div>
            </div>
        )
    }
}

export default SSOConnecting;